import { memo } from 'react';
import { cn } from '@divlab/divanui';
import { IconArrowRight } from '@divlab/divanui/icons';

import useTranslation from '@Queries/useTranslation';
import styles from './CylindoRotateHint.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface CylindoRotateHintProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  size?: 's' | 'm';
  view?: 'updated';
}

const CylindoRotateHint: FC<CylindoRotateHintProps> = (props) => {
  const { className, size = 's', view, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <div
      {...restProps}
      className={cn(
        styles.cylindoRotateHint,
        {
          [styles.sizeM]: size === 'm',
          [styles.sizeS]: size === 's',
          [styles.viewUpdated]: view === 'updated',
        },
        className,
      )}
    >
      <IconArrowRight className={styles.arrowPrev} />
      <div className={styles.text}>{t('ui.rotate-model')}</div>
      <IconArrowRight className={styles.arrowNext} />
    </div>
  );
};

export default memo(CylindoRotateHint);
